import { useTranslation } from 'react-i18next';
import type { ImageSourcePropType } from 'react-native';

export type Teacher = {
  name: string;
  initials: string;
  role: string;
  style: string;
  since?: number;
  color: 'wine' | 'ember' | 'gold' | 'verde' | 'sand' | 'lilac';
  trainee?: boolean;
  placeholder?: boolean;
  photo?: ImageSourcePropType;
};

type StaticData = Pick<
  Teacher,
  'initials' | 'since' | 'color' | 'trainee' | 'placeholder' | 'photo'
>;

const STATIC: Record<string, StaticData> = {
  manu: { initials: 'MM', since: 2015, color: 'wine', photo: require('../../assets/team/manu.jpg') },
  corinne: { initials: 'CH', since: 2017, color: 'ember', photo: require('../../assets/team/corinne.jpg') },
  michelle: { initials: 'MD', since: 2019, color: 'verde', photo: require('../../assets/team/michelle.jpg') },
  cyrill: { initials: 'CK', since: 2020, color: 'gold', photo: require('../../assets/team/cyrill.jpg') },
  andrea: { initials: 'AS', since: 2022, color: 'lilac', photo: require('../../assets/team/andrea.jpg') },
  amanda: { initials: 'AR', since: 2023, color: 'sand', photo: require('../../assets/team/amanda.jpg') },
  dajana: { initials: 'DS', color: 'wine', trainee: true, photo: require('../../assets/team/dajana.jpg') },
  julian: { initials: 'JF', color: 'verde', trainee: true },
  fabienne: { initials: 'FB', color: 'ember', trainee: true },
  yves: { initials: 'YB', color: 'gold', trainee: true },
};

type TeacherEntry = { key: string; name: string; role: string; style: string };

export function useTeachers(): Teacher[] {
  const { t } = useTranslation();
  const entries = t('team.teachers', { returnObjects: true }) as TeacherEntry[];
  return entries.map((e) => ({
    ...STATIC[e.key],
    name: e.name,
    role: e.role,
    style: e.style,
  }));
}
